export default __webpack_public_path__ + "static/media/Visualización de Datos (D3.js) - Linkedin.1342610c.png";